import React from 'react';
import { useTheme } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import ChartCard from './ChartCard';
import { SalesOverTimeItem } from './types';

interface DailySalesTrendChartProps {
  data: SalesOverTimeItem[];
}

const DailySalesTrendChart: React.FC<DailySalesTrendChartProps> = ({ data }) => {
  const theme = useTheme();

  return (
    <ChartCard title="Daily Sales Trend" timeout={1500}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 24, left: 8, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.grey[200]} />
          <XAxis dataKey="date" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary} />
          <RechartsTooltip
            formatter={(value: any) => [`₹${Number(value).toLocaleString()}`, 'Sales']}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="sales"
            name="Sales"
            stroke={theme.palette.primary.main}
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default DailySalesTrendChart;
